module.exports = "https://static.moomoo.com/components/common-redpacket/images/packet-1.6e6da5d592.png";